(function( $ ) {
    // $(document).ready(function () {
        var body = $("body");

        // Doc https://github.com/gabceb/jquery-browser-plugin
        
        if($.browser.msie) {
            body.addClass('browser-ie-' + $.browser.version.split(".")[0]);
        }
        
        if($.browser.ipad) {
            body.addClass('browser-ipad');
        }
        
        if($.browser.iphone) {
            body.addClass('browser-iphone');
        }
        
        if($.browser.msedge) {
            body.addClass('browser-edge');
        }
        
        if($.browser.desktop) {
            body.addClass('browser-desktop');
        }
        
        if($.browser.mobile) {
            body.addClass('browser-mobile');
        }
        
        //jQBrowser.uaMatch();
    // });
})(jQuery);